import { createSelector } from 'reselect';

export const getComponentState = state => state.layout;

export const getFields = createSelector(
    getComponentState,
    (state) => state.fields
);
export const getIsSending = createSelector(
    getComponentState,
    (state) => state.isSending
);
export const getOpenTickets = createSelector(
    getComponentState,
    (state) => state.openTickets
);
export const getFiles = createSelector(
    getComponentState,
    (state) => state.files
);
export const getFittingMonth = createSelector(
    getComponentState,
    (state) => state.fittingMonth
);
export const getFittingDate = createSelector(
    getComponentState,
    (state) => state.fittingDate
);
export const getCheckingFitting = createSelector(
    getComponentState,
    (state) => state.checkingFitting
);
export const getFittingReserved = createSelector(
    getComponentState,
    (state) => state.fittingReserved
);
